﻿export class SourceOfFundsDeclaration {
    public sourceOfFundsId: number;
    public otherDescription: string;
}
